<ng-container *ngIf="!eventService.loadEventTournaments; else loading">
<div class="championship">
  <h2> {{globalService?.customLang?.tournament}} </h2>
</div>
  <ng-container *ngIf="tournaments && tournaments.length > 0; else nodata">
<div class="tournament-container">
  <ng-container *ngFor="let tournament of tournaments" >
    <app-tournaments-reusable [tournament]="tournament" [backgroundImageBody]="'linear-gradient(255deg, rgba(203,48,102,1) 0%, rgba(203,48,102,1) 35%, rgba(22,191,253,1) 100%)'"
                              [colorBody]="'#ffffff'" [direction]="globalService?.langChosen" [fillColor]="'#ffffff'">
    </app-tournaments-reusable>
  </ng-container>

</div>
  </ng-container>
  </ng-container>
  <ng-template #nodata>
    <div class="container">
      <div class=" no-data">
        <h2>{{globalService.customLang.no_tournaments_yet}}</h2>
      </div>
    </div>
  </ng-template>

  <ng-template #loading>
    <app-loading-indicator></app-loading-indicator>
  </ng-template>
